import React from 'react';
import { ChevronDownIcon } from '@radix-ui/react-icons';

import { SingleSelectDropdown } from '../../../components/select-dropdown';
import { Bloc, BlocContent } from '../../../routes/project/components/step-drawer';

export interface SelectProps {
  label: string;
  value?: string;
  placeHolder?: string;
  options: any[];
  onSelect?: (el: any) => void;
  disabled?: boolean;
  name?: string;
}

export const SelectDrawer: React.FC<SelectProps> = ({ label, value, onSelect, options, name }) => (
  <SingleSelectDropdown
    trigger={(value) => (
      <Bloc data-row={true}>
        <label>{label}</label>

        <BlocContent>
          {value}

          <ChevronDownIcon />
        </BlocContent>
      </Bloc>
    )}
    title={name}
    value={value}
    options={options}
    onValueChange={onSelect}
  />
);
